import React, {useContext} from 'react';
import {TabbedOverviewPage, ScoreStructureSection, ReadinessSolutionScoresSection} from '../components/OverviewSections.comp';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

const AboutScoresPage = () => {
    const {authUser} = useContext(AuthContext);
    const stage = getPlanStage(authUser);

    // Slides 7-8 tag: "COS Readiness Solution Scores" = P1 only;
    // "COS Children Assessment Scores" = P0 + P1 (matches School's own gating).
    const tabs = [
        ...(stage === 'P1' ? [{label: 'COS Readiness Solution Scores', content: <ReadinessSolutionScoresSection/>}] : []),
        {label: 'COS Children Assessment Scores', content: <ScoreStructureSection/>},
    ];

    return <TabbedOverviewPage skipNoDataGate tabs={tabs}/>;
};

export default AboutScoresPage;
